// Only this small observer loads with the page. Fetch the player and metadata nearby.
const observe=()=>document.querySelectorAll('k52-playlist-carousel[data-module]').forEach(el=>{
  if(el.dataset.observed)return;el.dataset.observed='true';
  let loading=false;
  const load=async()=>{
    if(loading||!el.isConnected)return;loading=true;
    try{await import(el.dataset.module);await el.start();}
    catch{el.dataset.state='error';const status=el.querySelector('.knc__load-status');status.textContent='Videos could not load. Please try again.';status.hidden=false;const retry=el.querySelector('.knc__retry');retry.hidden=false;retry.onclick=load;}
    finally{loading=false;}
  };
  const observer=new IntersectionObserver(entries=>{if(entries.some(entry=>entry.isIntersecting)){observer.disconnect();load();}},{rootMargin:'300px 0px'});
  observer.observe(el);
});
observe();document.addEventListener('shopify:section:load',observe);
